export const MAILING_SETTINGS_API = '/api/dashboard/customer/settings/mailing'
